import { useClassNames } from '@factorialco/deprecated-design-system'
import emojiPath from 'emojis/emojis.svg'

import './index.styles.css'

const stylesRefs = {
  emoji: 'Emoji_emoji',
  small: 'Emoji_small',
  short: 'Emoji_short',
  medium: 'Emoji_medium',
  big: 'Emoji_big',
}

type Sizes = 'small' | 'short' | 'medium' | 'big'
interface Props {
  name: string
  size?: Sizes
}

export default function Emoji({ name, size }: Props) {
  const cx = useClassNames(stylesRefs)
  return (
    <svg aria-hidden="true" className={cx('emoji', size ?? 'medium')}>
      <use xlinkHref={`${emojiPath}#icon-${name}`} />
    </svg>
  )
}
